import React, { useState, useCallback, Fragment } from 'react';
import * as S from './style';
import { Label } from 'components';
import PopupImageGuide, {
  TGuideType,
  Props as PopupImageGuideProps,
} from 'components/molecules/Popup/ImageGuide';
import { ReactComponent as UploadIcon } from 'assets/img/common/ic_object_camera_fill.svg';
import {
  LABEL_IMG_UPLOAD,
  BUTTON_DELETE_IMAGE,
  CAPTION_IMAGE_UPLOAD,
} from 'commons/ZimssaString';
import { usePopup } from 'hooks';
export interface Props {
  value?: string;
  isDeleteBtn?: boolean;
  type: TGuideType;
  inputName: string;
  imgDir: string;
  onChangeHandler?: (type: any, value: string) => void;
}

function FileImgWithGuide({
  value,
  isDeleteBtn = true,
  type,
  inputName,
  imgDir,
  onChangeHandler,
}: Props): React.ReactElement {
  const { isShow, popupAction } = usePopup();
  const [imageName, setImageName] = useState<string>();
  const onClickImageDelete = useCallback(
    () => {
      onChangeHandler && onChangeHandler(inputName, '');
    },
    [onChangeHandler, inputName]
  );

  const onClickCallback = useCallback(
    () => {
      popupAction();
    },
    [popupAction]
  );

  const popupImageGuideProps: PopupImageGuideProps = {
    type: type,
    inputName: inputName,
    imgDir: imgDir,
    isShow: isShow,
    onClickPopupAction: popupAction,
    onChangeHandler: (type: any, value: string, imgName?: string) => {
      onChangeHandler && onChangeHandler(type, value);
      setImageName(imgName);
      popupAction();
    },
  };

  return (
    <Fragment>
      <PopupImageGuide {...popupImageGuideProps} />
      <S.FileImgContainer background={value}>
        {value ? (
          <S.ImageCover>
            <S.InfoWrapper>
              <Label
                contents={imageName}
                fontStyle={'body2_bold'}
                color={'gray_opacity_50'}
              />
              {isDeleteBtn ? (
                <S.BtnDelete
                  fontStyle={'body2'}
                  color={'gray_opacity_50'}
                  backGroundColor={'gray_opacity_400'}
                  onClick={onClickImageDelete}
                >
                  {BUTTON_DELETE_IMAGE}
                </S.BtnDelete>
              ) : null}
            </S.InfoWrapper>
            <Label
              contents={CAPTION_IMAGE_UPLOAD}
              fontStyle={'caption'}
              color={'gray_opacity_50'}
            />
          </S.ImageCover>
        ) : (
          <S.InputFileWrapper onClick={onClickCallback}>
            <S.LabelWrapper>
              <UploadIcon />
              <Label
                fontStyle={'body2'}
                color={'gray_opacity_800'}
                contents={LABEL_IMG_UPLOAD}
              />
            </S.LabelWrapper>
          </S.InputFileWrapper>
        )}
      </S.FileImgContainer>
    </Fragment>
  );
}

export default FileImgWithGuide;
